"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function Surprised() {
    return (jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(0.000000, 8.000000)' }, { children: [jsx_runtime_1.jsx("circle", { fill: '#FFFFFF', cx: '30', cy: '22', r: '14' }, void 0),
            jsx_runtime_1.jsx("circle", { fill: '#FFFFFF', cx: '82', cy: '22', r: '14' }, void 0),
            jsx_runtime_1.jsx("circle", { fillOpacity: '0.699999988', fill: '#000000', cx: '30', cy: '22', r: '6' }, void 0),
            jsx_runtime_1.jsx("circle", { fillOpacity: '0.699999988', fill: '#000000', cx: '82', cy: '22', r: '6' }, void 0)] }), void 0));
}
exports.default = Surprised;
